module.exports = __webpack_public_path__ + "media/images/rank_04-a1b4233fde3788f5d4466426f4b4de2b.png";